<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="open"
        class="fixed inset-0 z-[100] flex flex-col bg-background"
      >
        <!-- Header -->
        <div class="flex items-center justify-between border-b border-border px-5 py-5">
          <h2 class="text-xl font-semibold text-foreground">
            {{ title }}
          </h2>
          <button
            type="button"
            class="flex h-10 w-10 items-center justify-center rounded-xl transition-colors hover:bg-accent active:bg-accent"
            @click="close"
          >
            <Icon name="tabler:x" size="22" class="text-foreground" />
          </button>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-y-auto">
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { watch, onBeforeUnmount } from 'vue';

const props = defineProps<{
  /** Whether the overlay is open */
  open: boolean;
  /** Header title text */
  title: string;
}>();

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

function close() {
  emit('update:open', false);
}

// Lock body scroll when open
watch(
  () => props.open,
  (val) => {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = val ? 'hidden' : '';
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = '';
  }
});
</script>
